export const ITEMS_PER_PAGE = [6, 12, 24, 36];
